import React, { useState } from "react";
import {
  company_icon,
  email_icon,
  eye_icon,
  knf_logo,
  logo,
  mobile_icon,
  password_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { EMAIL } from "../redux/api/Constants";
import apiRequest from "../redux/api/apiRequest";
import { toast } from "react-toastify";
import { useForgotPasswordMutation } from "../redux/api/api";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";

const Registration = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [err, setErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [forgotPassword] = useForgotPasswordMutation();

  const resetPassword = async () => {
    if (!email || !email?.match(EMAIL)) {
      setErr(true);
      return;
    }
    const formdata = new FormData();
    formdata.append("email", email);
    setErr(false);
    setLoader(true);
    const res = await apiRequest(forgotPassword, formdata);
    setLoader(false);
    if (res?.status == "success") {
      navigate("/");
      toast.success(res?.message);
    }
    console.log(res);
  };
  return (
    <div className="d-flex ac-jc w-100 vh-100 new_login_page">
      <div className="main">
        <div className="login-right">
          <img src={knf_logo} className="logo" alt="" />
          <h2 className="mt-4 f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-26 fs-xxl-28 white">
            Forgot Password
          </h2>
          <div className="text-start">
            <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 white">
              Email
            </p>
            <div className="login-input mt-2">
              <MailOutlineRoundedIcon className="emial-icon" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
            </div>
            {err && (
              <p className="err" style={{ color: "white", marginTop: "2%" }}>
                Please enter Valid Email
              </p>
            )}
          </div>

          <button
            disabled={loader}
            onClick={() => {
              resetPassword();
            }}
            className="login-btn f2"
          >
            {loader && (
              <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ marginRight: "5px" }}
              ></div>
            )}
            Submit
          </button>
          <div className="d-flex justify-content-start mt-1">
            <p
              onClick={() => navigate("/")}
              className="mt-5 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 white pointer text-start"
            >
              Return to Login
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
